import {usePages} from "../api/pageapi";
import {BasePageLayout} from "../components/grouping/BasePageLayout";

export function TechnicalDirectionPage(props) {
    const {pages} = usePages();

    return <BasePageLayout>
        <div dangerouslySetInnerHTML={{__html: pages ? pages[1]?.htmlFragment?.html : ""}}>

        </div>
    </BasePageLayout>
}